import { EventBus } from '@/utils/EventBus'
export const VerificationPopupMixin = {
  methods: {
    async executeAction() {
      // currently reverting the verification is prohibited
      // it might be enabled in the future that's why
      // the logics are not removed
      const action = this.details.status === 'Unverified' ? 'V' : 'U'
      const toastTitle =
        this.details.status === 'Unverified'
          ? 'Report Verification'
          : 'Report Verification Reverted'
      const toastText =
        this.details.status === 'Unverified'
          ? 'The report is marked as verified.'
          : 'The report verification is reverted.'

      const formData = new FormData()
      formData.append('admin_remarks', this.adminRemarks ?? '')
      formData.append('deduct_point', this.deductPoints)
      formData.append('status', action)

      this.isLoading = true
      await this.$http
        .patch(this.$config.report.api.update(this.details.id), formData)
        .then((res) => {
          this.$emit('change', res.data)
          this.$refs.popup.hide()

          this.$notify({
            group: 'generic',
            type: 'success',
            title: toastTitle,
            text: toastText,
          })
          EventBus.$emit('refresh-report-logs')
        })
        .catch((err) => {
          console.warn(err)
          this.message = 'Failed to refund! (' + err.status + ')'
          this.$emit('failed', err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
